import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SiteLayout from "@/components/SiteLayout";
import { api } from "@/lib/api";

function formatDate(iso) {
  try { return new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" }); } catch { return ""; }
}

export default function InsightsIndex() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/insights").then((r) => setItems(r.data)); }, []);
  return (
    <SiteLayout>
      <section className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 pt-10 md:pt-20" data-testid="insights-page">
        <h1 className="h-display text-[clamp(2.4rem,7vw,6rem)] max-w-[16ch]">
          Considered writing<br />on the matters at hand.
        </h1>
        <p className="mt-10 max-w-2xl text-graphite/80 leading-relaxed">
          Notes, briefings and longer-form analysis from the partners and lawyers of Carlton Elleker Chase.
        </p>
      </section>

      <section className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 py-16 md:py-24">
        <div className="hairline-top" data-testid="insights-list">
          {items.map((it) => (
            <Link
              key={it.slug}
              to={`/insights/${it.slug}`}
              className="num-list-row hairline-bottom grid grid-cols-12 gap-4 md:gap-8 py-10 md:py-12"
              data-testid={`insight-link-${it.slug}`}
            >
              <div className="col-span-12 md:col-span-3 text-xs text-graphite/55">
                {formatDate(it.published_at || it.created_at)}<br />
                <span className="text-[#1E3668]">{it.category}</span>
              </div>
              <div className="col-span-12 md:col-span-7">
                <h2 className="num-title text-2xl md:text-4xl font-semibold tracking-tight max-w-3xl">{it.title}</h2>
                {it.subtitle && <p className="mt-3 text-graphite/75 leading-relaxed max-w-3xl">{it.subtitle}</p>}
              </div>
              <div className="hidden md:flex md:col-span-2 justify-end num-arrow">
                <ArrowUpRight size={26} className="text-[#1E3668]" />
              </div>
            </Link>
          ))}
        </div>
        {items.length === 0 && (
          <p className="text-center text-graphite/55 py-20">No insights published yet.</p>
        )}
      </section>
    </SiteLayout>
  );
}
